import { lazy } from "react";

const CHUNK_RE = /Loading (CSS )?chunk|ChunkLoadError|Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module/i;
const KEY = "chunk-reloaded-at";
const GUARD_MS = 60000;

export const isChunkError = (err) => CHUNK_RE.test(`${err?.name || ""} ${err?.message || err}`);

// After a deploy, old chunk hashes vanish — reload once (per minute) to fetch the new build.
export function reloadForNewBuild() {
  const last = Number(sessionStorage.getItem(KEY) || 0);
  if (Date.now() - last < GUARD_MS) return false;
  sessionStorage.setItem(KEY, String(Date.now()));
  window.location.reload();
  return true;
}

export function lazyWithRetry(factory) {
  return lazy(async () => {
    try {
      return await factory();
    } catch (err) {
      if (isChunkError(err) && reloadForNewBuild()) return new Promise(() => {});
      throw err;
    }
  });
}
